import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  accessDenied: boolean;
  authenticationRequired: boolean;
}

const initialState: AuthState = {
  accessDenied: false,
  authenticationRequired: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAccessDenied: (state, action: PayloadAction<{ accessDenied: boolean }>): void => {
      state.accessDenied = action.payload.accessDenied;
    },
    setAuthenticationRequired: (state, action: PayloadAction<{ authenticationRequired: boolean }>): void => {
      state.authenticationRequired = action.payload.authenticationRequired;
    },
  },
});

export const { setAccessDenied, setAuthenticationRequired } = authSlice.actions;

export default authSlice.reducer;
